const PROFILE_ALL = '-ALL';
const PROFILE_AGT = '-AGT';
const PROFILE_AD = '-AD';
const PROFILE_GAD = '-GAD';
const PROFILE_BNK = '-BNK';

const CAT_ALL = '-ALL';
const CAT_IS = '-IS';
export const CAT_LBS = '-LBS';

const IND = '-IND';
const MGR = '-MGR';
const NON_SALES = '-NS';

export const ANY = '*';
export const GUEST = 'GUEST';
export const AGENCY_NOUS = 'agencyNous';
export const AGENCY = 'agency';
export const NOUS = 'nous';
export const DLS = 'dls';
export const PS = 'ps';
export const ACB = 'acb';
export const TPB = 'tpb';

/* Agency */
// Channel code
export const AGNT_CHNL = 'AGNT_CHNL';
// Full role code
export const AGC_AGT = AGNT_CHNL + PROFILE_AGT + CAT_ALL + IND;
export const AGC_AGT_MNGR = AGNT_CHNL + PROFILE_AGT + CAT_ALL + MGR;
export const AGC_AD = AGNT_CHNL + PROFILE_AD + CAT_ALL + IND;
export const AGC_AD_MNGR = AGNT_CHNL + PROFILE_AD + CAT_ALL + MGR;
export const AGC_GAD = AGNT_CHNL + PROFILE_GAD + CAT_ALL + IND;
export const AGC_GAD_MNGR = AGNT_CHNL + PROFILE_GAD + CAT_ALL + MGR;

// All agent AD roles
export const AGENCY_AD_CHANNEL = [AGC_AD, AGC_AD_MNGR];

// All roles
export const AGENCY_CHANNEL = [
  AGC_AGT,
  AGC_AGT_MNGR,
  AGC_AD,
  AGC_AD_MNGR,
  AGC_GAD,
  AGC_GAD_MNGR,
];

export const AGENCY_CHANNEL_MANAGER = [
  AGC_AGT_MNGR,
  AGC_AD,
  AGC_AD_MNGR,
  AGC_GAD,
  AGC_GAD_MNGR,
];

/* Partnership */
// Channel code
export const PARTNERSHIP =
  '(SAMO_CHNL|CCJ_CHNL|MED_CHNL|QLA_CHNL|TCA_CHNL|PHANC_CHNL|MARS_CHNL)';
export const PHANC_CHNL = 'PHANC_CHNL';
export const SAMO_CHNL = 'SAMO_CHNL';
export const CCJ_CHNL = 'CCJ_CHNL';
export const TCA_CHNL = 'TCA_CHNL';
export const QLA_CHNL = 'QLA_CHNL';
export const MED_CHNL = 'MED_CHNL';
export const MARS_CHNL = 'MARS_CHNL';
// Full role code
// Phanclub
export const PHANCLUB_AGT = PHANC_CHNL + PROFILE_AGT + CAT_ALL + IND;
export const PHANCLUB_AGT_MNGR = PHANC_CHNL + PROFILE_AGT + CAT_ALL + MGR;
export const PHANCLUB_AD = PHANC_CHNL + PROFILE_AD + CAT_ALL + IND;
export const PHANCLUB_AD_MNGR = PHANC_CHNL + PROFILE_AD + CAT_ALL + MGR;
// Samo
export const SAMO_AGT = SAMO_CHNL + PROFILE_AGT + CAT_ALL + IND;
export const SAMO_AGT_MNGR = SAMO_CHNL + PROFILE_AGT + CAT_ALL + MGR;
export const SAMO_AD = SAMO_CHNL + PROFILE_AD + CAT_ALL + IND;
export const SAMO_AD_MNGR = SAMO_CHNL + PROFILE_AD + CAT_ALL + MGR;
// Ccj
export const CCJ_AGT = CCJ_CHNL + PROFILE_AGT + CAT_ALL + IND;
export const CCJ_AGT_MNGR = CCJ_CHNL + PROFILE_AGT + CAT_ALL + MGR;
export const CCJ_AD = CCJ_CHNL + PROFILE_AD + CAT_ALL + IND;
export const CCJ_AD_MNGR = CCJ_CHNL + PROFILE_AD + CAT_ALL + MGR;
// Tca
export const TCA_AGT = TCA_CHNL + PROFILE_AGT + CAT_ALL + IND;
export const TCA_AGT_MNGR = TCA_CHNL + PROFILE_AGT + CAT_ALL + MGR;
export const TCA_AD = TCA_CHNL + PROFILE_AD + CAT_ALL + IND;
export const TCA_AD_MNGR = TCA_CHNL + PROFILE_AD + CAT_ALL + MGR;
// Qoala
export const QOALA_AGT = QLA_CHNL + PROFILE_AGT + CAT_ALL + IND;
export const QOALA_AGT_MNGR = QLA_CHNL + PROFILE_AGT + CAT_ALL + MGR;
export const QOALA_AD = QLA_CHNL + PROFILE_AD + CAT_ALL + IND;
export const QOALA_AD_MNGR = QLA_CHNL + PROFILE_AD + CAT_ALL + MGR;
// Medici
export const MEDICI_AGT = MED_CHNL + PROFILE_AGT + CAT_ALL + IND;
export const MEDICI_AGT_MNGR = MED_CHNL + PROFILE_AGT + CAT_ALL + MGR;
export const MEDICI_AD = MED_CHNL + PROFILE_AD + CAT_ALL + IND;
export const MEDICI_AD_MNGR = MED_CHNL + PROFILE_AD + CAT_ALL + MGR;
// Mars
export const MARS_AGT = MARS_CHNL + PROFILE_AGT + CAT_ALL + IND;
export const MARS_AGT_MNGR = MARS_CHNL + PROFILE_AGT + CAT_ALL + MGR;
export const MARS_AD = MARS_CHNL + PROFILE_AD + CAT_ALL + IND;
export const MARS_AD_MNGR = MARS_CHNL + PROFILE_AD + CAT_ALL + MGR;
// All sub channels
export const PARTNERSHIP_AGT = PARTNERSHIP + PROFILE_AGT + CAT_ALL + IND;
export const PARTNERSHIP_AGT_MNGR = PARTNERSHIP + PROFILE_AGT + CAT_ALL + MGR;
export const PARTNERSHIP_AD = PARTNERSHIP + PROFILE_AD + CAT_ALL + IND;
export const PARTNERSHIP_AD_MNGR = PARTNERSHIP + PROFILE_AD + CAT_ALL + MGR;
// All roles
export const PARTNERSHIP_CHANNEL = [
  PARTNERSHIP_AGT,
  PARTNERSHIP_AGT_MNGR,
  PARTNERSHIP_AD,
  PARTNERSHIP_AD_MNGR,
];

/* Flair */
// Channel code
export const TURNP_CHNL = 'TURNP_CHNL';
export const ACB_CHNL = 'ACB_CHNL';
// Full role code
// Tpb
export const TPB_BNK = TURNP_CHNL + PROFILE_BNK + CAT_ALL + IND;
export const TPB_AD = TURNP_CHNL + PROFILE_AD + CAT_ALL + IND;
export const TPB_AD_MNGR = TURNP_CHNL + PROFILE_AD + CAT_ALL + MGR;
export const TPB_CHANNEL = [TPB_BNK, TPB_AD, TPB_AD_MNGR];
export const TPB_CHANNEL_MANAGER = [TPB_AD, TPB_AD_MNGR];
// Acb
export const ACB_BNK = ACB_CHNL + PROFILE_BNK + CAT_LBS + IND;
export const ACB_BNK_MNGR = ACB_CHNL + PROFILE_BNK + CAT_ALL + MGR;
export const ACB_AGT = ACB_CHNL + PROFILE_AGT + CAT_IS + IND;
export const ACB_AGT_MNGR = ACB_CHNL + PROFILE_AGT + CAT_ALL + MGR;
export const ACB_AD = ACB_CHNL + PROFILE_AD + CAT_ALL + IND;
export const ACB_AD_MNGR = ACB_CHNL + PROFILE_AD + CAT_ALL + MGR;
export const ACB_NON_SALES = ACB_CHNL + PROFILE_ALL + CAT_ALL + NON_SALES;
export const ACB_CHANNEL = [
  ACB_BNK,
  ACB_BNK_MNGR,
  ACB_AGT,
  ACB_AGT_MNGR,
  ACB_AD,
  ACB_AD_MNGR,
];
export const ACB_CHANNEL_MANAGER = [ACB_BNK_MNGR, ACB_AGT_MNGR, ACB_AD_MNGR];
// All roles
export const FLAIR_CHANNEL = [
  TPB_BNK,
  TPB_AD,
  TPB_AD_MNGR,
  ACB_BNK,
  ACB_BNK_MNGR,
  ACB_AGT,
  ACB_AGT_MNGR,
  ACB_AD,
  ACB_AD_MNGR,
];

export const FLAIR_CHANNEL_INDIVIDUAL = [TPB_BNK, ACB_BNK, ACB_AGT];

export const FLAIR_CHANNEL_MANAGER = [
  TPB_AD,
  TPB_AD_MNGR,
  ACB_BNK_MNGR,
  ACB_AGT_MNGR,
  ACB_AD,
  ACB_AD_MNGR,
];

export const FLAIR_CHANNEL_NON_BNK = [
  ACB_AGT,
  ACB_AGT_MNGR,
  ACB_AD,
  ACB_AD_MNGR,
  TPB_BNK,
  TPB_AD,
  TPB_AD_MNGR,
];

export const ALL_CHANNEL = [
  ...AGENCY_CHANNEL,
  ...PARTNERSHIP_CHANNEL,
  ...FLAIR_CHANNEL,
];

export const ALL_CHANNEL_NON_BNK = [
  ...AGENCY_CHANNEL,
  ...PARTNERSHIP_CHANNEL,
  ...FLAIR_CHANNEL_NON_BNK,
];

export const ALL_CHANNEL_INDIVIDUAL = [
  AGC_AGT,
  ACB_BNK,
  ACB_AGT,
  TPB_BNK,
  PARTNERSHIP_AGT,
];

export const ALL_CHANNEL_INDIVIDUAL_NONE_LBS = [
  AGC_AGT,
  ACB_AGT,
  TPB_BNK,
  PARTNERSHIP_AGT,
];

export const ALL_CHANNEL_INDIVIDUAL_NON_BNK = [
  AGC_AGT,
  ACB_AGT,
  TPB_BNK,
  PARTNERSHIP_AGT,
];

export const ALL_CHANNEL_MANAGER = [
  AGC_AGT_MNGR,
  AGC_AD,
  AGC_AD_MNGR,
  AGC_GAD,
  AGC_GAD_MNGR,
  ACB_BNK_MNGR,
  ACB_AGT_MNGR,
  ACB_AD,
  ACB_AD_MNGR,
  TPB_AD,
  TPB_AD_MNGR,
  PARTNERSHIP_AGT_MNGR,
  PARTNERSHIP_AD,
  PARTNERSHIP_AD_MNGR,
];

export const CHANNEL_AD = [
  AGC_AD,
  AGC_AD_MNGR,
  ACB_AD,
  ACB_AD_MNGR,
  TPB_AD,
  TPB_AD_MNGR,
  PARTNERSHIP_AD,
  PARTNERSHIP_AD_MNGR,
];

/* Channels map */
export const SALES_PORTAL_PERSISTENCE_CHANNEL_MAP = {
  [AGENCY_NOUS]: AGENCY_CHANNEL,
  [PS]: PARTNERSHIP_CHANNEL,
  [ACB]: [...ACB_CHANNEL, ACB_NON_SALES],
  [TPB]: TPB_CHANNEL,
};

export const SALES_PORTAL_CHANNEL_MAP = {
  [AGENCY]: AGENCY_CHANNEL,
  [PS]: PARTNERSHIP_CHANNEL,
  [ACB]: [...ACB_CHANNEL, ACB_NON_SALES],
  [TPB]: TPB_CHANNEL,
};

/* Roles map */
export const SALES_PORTAL_ROLE_CODE_MAP = {
  AGT: [AGC_AGT, ACB_AGT, TPB_BNK, PARTNERSHIP_AGT, ACB_BNK],
  LEADER: [AGC_AGT_MNGR, ACB_AGT_MNGR, PARTNERSHIP_AGT_MNGR, ACB_NON_SALES],
  AD: [
    AGC_AD,
    AGC_AD_MNGR,
    ACB_AD,
    ACB_AD_MNGR,
    TPB_AD,
    TPB_AD_MNGR,
    PARTNERSHIP_AD,
    PARTNERSHIP_AD_MNGR,
  ],
  GAD: [AGC_GAD, AGC_GAD_MNGR],
};

/* Permissions by features */
export const AGENT_ONLINE_REQUEST = [
  ...AGENCY_CHANNEL,
  ...FLAIR_CHANNEL_NON_BNK,
];

export const TRAJET_REPORT = [...AGENCY_CHANNEL, ...FLAIR_CHANNEL];

export const CHECK_IN = [AGNT_CHNL];

export const LEAD = [ACB_BNK, ACB_BNK_MNGR, ACB_AGT, TPB_BNK];

export const FEE = [AGC_AGT];
